import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import Localization from "../../../localization";

class Step1Form extends Component {
    constructor(props) {
        super(props);

        this.myRef = React.createRef();
    }

    componentDidMount() {
        this.props.myRef(this.myRef);
    }

    render() {
        const { locale, values } = this.props;

        const registSchema = Yup.object().shape({
            name: Yup.string().required(
                Localization[locale].validation.required
            ),
        });

        const initialValues = {
            name: (values && values.name) || "",
        };

        return (
            <Formik
                initialValues={initialValues}
                validationSchema={registSchema}
                innerRef={this.myRef}
                onSubmit={(values) => {}}
            >
                {({ values, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <p className="font-bold text-20 xl:text-30 text-blue mb-26 xl:mb-60">
                            {Localization[locale].register.step_1_name_title}
                        </p>
                        <div>
                            <Field
                                type="text"
                                name="name"
                                className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                placeholder={
                                    Localization[locale].register
                                        .step_1_name_placeholder
                                }
                            />
                            <p className="text-red text-12 mt-6">
                                <ErrorMessage name="name" />
                            </p>
                        </div>
                    </form>
                )}
            </Formik>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Step1Form);
